import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { AdminLayout } from './components/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import Users from './pages/Users';
import Branding from './pages/Branding';
import MediaLibrary from './pages/MediaLibrary';
import CustomizeProperty from './pages/CustomizeProperty';
import EntityManager from './pages/EntityManager';
import PageEditor from './pages/PageEditor';
import GuestAccess from './pages/GuestAccess';
import Subscription from './pages/Subscription';
import GlobalCatalog from './pages/GlobalCatalog';
import CatalogSelection from './pages/CatalogSelection';
import Monitor from './pages/Monitor';
import ScanAnalytics from './pages/ScanAnalytics';

const CATALOG_ENTITIES = ['events', 'places', 'museums', 'services', 'experiences'];

function Protected({ children }) {
  const { user, tenant, loading } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center bg-paelbi-bg text-paelbi-ink/50">Caricamento...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role === 'partner') return <Navigate to="/partner" replace />;
  if (user.role === 'tenant_admin' && tenant && !tenant.published && !(tenant.settings?.onboarding?.completed)) {
    return <Navigate to="/onboarding/wizard" replace />;
  }
  return <AdminLayout>{children}</AdminLayout>;
}

function SectionRoute() {
  const { key } = useParams();
  if (CATALOG_ENTITIES.includes(key)) return <CatalogSelection entityKey={key} key={key} />;
  return <EntityManager entityKey={key} key={key} />;
}
function PageRoute() {
  const { key } = useParams();
  return <PageEditor pageKey={key} key={key} />;
}

export function AdminApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="" element={<Protected><Dashboard /></Protected>} />
        <Route path="tenants" element={<Protected><Tenants /></Protected>} />
        <Route path="users" element={<Protected><Users /></Protected>} />
        <Route path="catalog" element={<Protected><GlobalCatalog /></Protected>} />
        <Route path="monitor" element={<Protected><Monitor /></Protected>} />
        <Route path="branding" element={<Protected><Branding /></Protected>} />
        <Route path="customize" element={<Protected><CustomizeProperty /></Protected>} />
        <Route path="guest-access" element={<Protected><GuestAccess /></Protected>} />
        <Route path="scans" element={<Protected><ScanAnalytics /></Protected>} />
        <Route path="subscription" element={<Protected><Subscription /></Protected>} />
        <Route path="media" element={<Protected><MediaLibrary /></Protected>} />
        <Route path="section/:key" element={<Protected><SectionRoute /></Protected>} />
        <Route path="page/:key" element={<Protected><PageRoute /></Protected>} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default AdminApp;
